import { Link } from "react-router-dom"

const HbCart = (props) => {
  return (
    <li className="HbCart hb-link-item nav-item">
      <Link
        className="nav-link d-flex align-items-center w-100"
        onClick={props.closeMenu}
        to="/cart"
        style={{ gap: "12px" }}
      >
        {/* Icon */}
        <div className="d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
          </svg>
        </div>

        {/* Text */}
        <span className="hb-link-text">Cart</span>
      </Link>
    </li>
  )
}

export default HbCart
